<div class="header"></div>
<div class="content">
  <img src="/assets/common/phone-asset.png" />
  <div class="text">
    <p id="title">{{ configuracion.titulo }}</p>
    <p id="sub-title">{{ configuracion.mensaje }}</p>
    <div class="container-button">
      <ion-button class="button-save" (click)="logOut()">{{
        configuracion.boton_aceptar
      }}</ion-button>
    </div>
  </div>
</div>
